var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__wrapper",class:'page-'+_vm.kapitel + ' ' + 'page-'+_vm.kapitel+'-'+_vm.pageid},[(_vm.component)?_c(_vm.component,{key:_vm.componentKey,tag:"component",attrs:{"kapitel":_vm.kapitel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }